import {Component, EventEmitter, Output} from '@angular/core';
import _ from 'lodash';
import {GeneralService} from "../../services/generalService";
import {RouteService} from "../../services/routeService";
import {DICTIONARY} from "../../dictionary";
import {NotificationService} from "../../services/notificationService";


@Component({
	selector: 'exchange-junk-rule-wizard-c',
	templateUrl: './exchange-junk-rule-wizard.component.html',
})
export class ExchangeJunkRuleWizardComponent {

	@Output() closePopupFn: EventEmitter<any> = new EventEmitter<any>();

	constructor(private rs: RouteService,
				public gs: GeneralService, private ns: NotificationService) {}

	dic = DICTIONARY;
	_ = _;

	ipAddresses = [
		'3.93.139.220', '3.93.243.176', '3.251.32.127', '54.195.145.1',
		'52.37.228.167', '52.89.220.23', '3.221.25.19', '34.192.117.166',
		'44.209.231.3', '35.172.145.174'
	];

	// environment
	validSteps = [DICTIONARY.CONSTANTS.exchangeRulesSteps.generalInformation, DICTIONARY.CONSTANTS.exchangeRulesSteps.summary];
	step = this.dic.CONSTANTS.exchangeRulesSteps.generalInformation;
	errorMsg = '';
	ruleStatus;
	junkRuleInProcess;
	popupClosed = false;

	closePopup = () => {
		this.popupClosed = true;
		this.closePopupFn.emit({success: null, disconnected: null});
	}

	createJunkRule(): void {
		this.ruleStatus = null;
		this.junkRuleInProcess = true;
		this.rs.exchangeCreateJunkRule().then(response => {
			this.getPsCommandStatus();
		}, err => {
			this.ruleStatus = {status: 'failure', message: err.data.message};
			this.junkRuleInProcess = false;
		});
	}

	getPsCommandStatus = () => {
		this.rs.getPsCommandStatus('junkRule').then(response => {
			console.log(response);
			if (response.status === 'in process') {
				setTimeout(() => {
					this.getPsCommandStatus();
				}, 5000);
			}
			else {
				this.junkRuleInProcess = false;
				this.ruleStatus = response;
			}
		});
	}

	backStep = () => {
		this.errorMsg = '';
		switch (this.step) {
			case this.dic.CONSTANTS.exchangeRulesSteps.summary:
				if (this.junkRuleInProcess) {
					this.errorMsg = this.dic.ERRORS.waitForJunkRuleGenerate;
					return;
				}
				this.step = this.dic.CONSTANTS.exchangeRulesSteps.generalInformation;
				break;

			default:
				return;
		}
	}

	nextStep = () => {
		this.errorMsg = '';
		switch (this.step) {
			case this.dic.CONSTANTS.exchangeRulesSteps.generalInformation:
				this.createJunkRule();
				this.step = this.dic.CONSTANTS.exchangeRulesSteps.summary;
				break;

			default:
				return;
		}
	}
}
